export const resaleRedirect = (country, language) => {
  let resaleUrl = "resale.arcteryx.com";
  if (country?.toLowerCase() === "ca") {
    resaleUrl = language && language === "fr" ? "resale.arcteryx.ca/fr" : "resale.arcteryx.ca";
  }
  return resaleUrl;
};
